<h2 mat-dialog-title>Pagamento manual</h2>

<mat-dialog-content>
  <div class="modal-overlay" *ngIf="loading">
    <mat-progress-spinner
      diameter="48"
      strokeWidth="4"
      mode="indeterminate"
      class="modal-overlay-spinner"
    ></mat-progress-spinner>
  </div>

  <section class="readonly">
    <div><strong>Profissional:</strong> {{ data.doctorName || '-' }}</div>
    <div><strong>Especialidade:</strong> {{ data.specialtyName || '-' }}</div>
    <div><strong>Valor:</strong> {{ formattedAmount }}</div>
    <div><strong>ID Indicação:</strong> {{ data.indicationId || '-' }}</div>
  </section>

  <p class="info-text">
    Informe o motivo do pagamento manual. A observação será registrada junto com a operação e utilizada para rastreabilidade.
  </p>

  <form [formGroup]="form" (ngSubmit)="submit()">
    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Observação</mat-label>
      <textarea
        matInput
        rows="4"
        formControlName="observation"
        placeholder="Descreva o motivo para realizar este pagamento manual"
      ></textarea>
      <mat-error *ngIf="form.get('observation')?.hasError('required')">
        Preencha o motivo do pagamento.
      </mat-error>
      <mat-error *ngIf="form.get('observation')?.hasError('minlength')">
        Escreva pelo menos 3 caracteres.
      </mat-error>
      <mat-error *ngIf="form.get('observation')?.hasError('maxlength')">
        Máximo de 500 caracteres.
      </mat-error>
    </mat-form-field>

    <div class="actions">
      <button mat-stroked-button type="button" class="cancel" (click)="close()">
        Cancelar
      </button>
      <button
        mat-flat-button
        color="primary"
        type="submit"
        class="save"
        [disabled]="loading"
      >
        <ng-container *ngIf="!loading; else saving">
          Confirmar
        </ng-container>
        <ng-template #saving>
          <mat-progress-spinner
            diameter="20"
            strokeWidth="3"
            mode="indeterminate"
            class="modal-spinner"
          ></mat-progress-spinner>
        </ng-template>
      </button>
    </div>
  </form>
</mat-dialog-content>
